var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Reject",
        visible: _vm.isOpen,
        width: "7rem",
        "append-to-body": "",
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
        close: _vm.close,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "pageForm",
          staticClass: "page-form",
          attrs: { model: _vm.pageData, rules: _vm.pageRules },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: { prop: "refusalReason", label: "Approval Instructions" },
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  "auto-complete": "off",
                  placeholder: "Please fill in",
                },
                model: {
                  value: _vm.pageData.refusalReason,
                  callback: function ($$v) {
                    _vm.$set(_vm.pageData, "refusalReason", $$v)
                  },
                  expression: "pageData.refusalReason",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer page-btns",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.close("cancel")
                },
              },
            },
            [_vm._v("Cancel")]
          ),
          _vm._v(" "),
          _c("loading-btn", {
            attrs: { type: "primary", label: "Submit" },
            on: { clickHandle: _vm.approval },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }